import {useDispatch, useSelector} from "react-redux";
import {category_click, filterCategorySelect} from "../redux/actions";

export const Categoriesfilter = () => {
    const dispatch = useDispatch()
    const translate = useSelector(state => state.app.translate)
    const app_lang = useSelector(state => state.app.app_lang)
    const aircategories = useSelector(state => state.app.aircategories)
    const categories = useSelector(state => state.app.categories)
    const current_category = useSelector(state => state.app.current_category)
    const isMobile = useSelector(state => state.app.isMobile)


    let list = [];
    if (aircategories.length > 0 && categories.length > 0) {
        aircategories.forEach((item) => {
            if (item.fields.locale && item.fields.locale === app_lang) {
                if (item.fields.id === 0) {
                    let cat = {
                        id: item.fields.id,
                        name: item.fields.name,
                        slug: '',
                        checked: ('' === current_category) ? true : false
                    }
                    list.push(cat);
                }
                if (item.fields.id > 0 && item.fields.name.length > 0 && item.fields.slug.length > 0) {
                    let isset_category = false;
                    categories.forEach((subitem, id) => {
                        if (parseInt(item.fields.id) === parseInt(id)) {
                            isset_category = true;
                        }
                    });
                    if (isset_category) {
                        let cat = {
                            id: item.fields.id,
                            name: item.fields.name,
                            slug: item.fields.slug,
                            checked: (item.fields.slug === current_category) ? true : false
                        }
                        list.push(cat);
                    }
                }
            }
        })
    }
    const handleSelectRadio = (slug, name) => {
        category_click(name)
        dispatch(filterCategorySelect(slug))
    }
    const handleSelect = (e) => {
        let slug = e.target.value
        list.forEach(function (item) {
            if (slug === item.slug) {
                category_click(item.name)
            }
        })

        dispatch(filterCategorySelect(slug))
    }
    const handleLinkClick = (e,slug, name) => {
        e.preventDefault();
        category_click(name)
        dispatch(filterCategorySelect(slug))
    }

    if (list.length > 0) {
        if (isMobile) {
            return (
                <div className="categories-filter">
                    <div className="categories-filter__heading">{translate.select_category_label}</div>
                    <select onChange={(e) => handleSelect(e)} value={current_category}>
                        {
                            list.map((item) => {
                                return (
                                    <option key={item.id} value={item.slug}>
                                        {item.name}
                                    </option>
                                )
                            })
                        }
                    </select>
                </div>)
        }
        return (
            <div className="categories-filter">
                <div className="categories-filter__heading">{translate.select_category_label}</div>
                <div className="categories-filter__items">
                    {
                        list.map((item) => {
                            return (
                                <label  key={item.id} className="categories-filter__item"
                                   >
                                    <input type="radio" name="filter_category" value={item.slug}
                                           onChange={() => handleSelectRadio(item.slug, item.name)}
                                           checked={item.checked}/>
                                    <a href={item.slug.replace('other','')} onClick={(e) => handleLinkClick(e,item.slug, item.name)}>{item.name}</a>
                                </label>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
    return null;
}